module.exports = __webpack_public_path__ + "static/media/icon-location.0f65814b.svg";